export default __webpack_public_path__ + "static/media/hub_register-background.aee8db4c.svg";